import { render, staticRenderFns } from "./AttributeUserReview.vue?vue&type=template&id=036762a4"
import script from "./AttributeUserReview.vue?vue&type=script&lang=ts"
export * from "./AttributeUserReview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports